<template>
  <nav>
    <PflegeButton
      :label="props.submitButtonLabel"
      :disabled="disableSubmitButton"
      :loading="submitButtonLoading"
      size="2.5rem"
      @click="emit('submit')"
    />
    <PflegeButton
      :label="props.cancelButtonLabel"
      variant="secondary"
      size="2.5rem"
      @click="emit('cancel')"
    />
  </nav>
</template>

<script setup>
const props = defineProps({
  cancelButtonLabel: {
    type: String,
    required: true
  },
  submitButtonLabel: {
    type: String,
    required: true
  },
  disableSubmitButton: {
    type: Boolean,
    required: false,
    default: false
  },
  submitButtonLoading: {
    type: Boolean,
    required: false,
    default: false
  }
})
const emit = defineEmits(['submit', 'cancel'])
</script>

<style scoped>
nav {
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 0.5rem 1rem;
}
@supports not (contain: inline-size) {
  @media (max-width: 610px) {
    nav {
      flex-direction: column;
      gap: 0.5rem;
    }
  }
}
@container (width <= 600px) {
  nav {
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
